angular.module('picmonic-common').filter('safeURL', [
  '$sce',
  function ($sce) {
    return function (url) {
      return $sce.trustAsResourceUrl(url);
    };
  },
]);
